import { createAsyncThunk } from "@reduxjs/toolkit";
import { END_USERS } from "../../API/UserApi";
import axios from "axios";
import apiHeader from "../../Components/ApiHeader";

export const getUserListAPI: any = createAsyncThunk(
  "getUserList",
  async (params: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.get(END_USERS, {
        // headers: {
        //   token: JSON.parse(token),
        // },
        // timeout: 15000,
        headers: commonHead,
        params: params,
      });

      return {
        users: res,
      };
    } catch (error: any) {
      // if (error instanceof Error) {
      return rejectWithValue({
        error: { code: error.response.status, message: error.message },
      });
      // }
    }
  }
);
